import { render, staticRenderFns } from "./MultiSelectDropdown.vue?vue&type=template&id=039b1cd5&scoped=true"
import script from "./MultiSelectDropdown.vue?vue&type=script&lang=js"
export * from "./MultiSelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectDropdown.vue?vue&type=style&index=0&id=039b1cd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039b1cd5",
  null
  
)

export default component.exports